export default "/images/vendor/flag-icons/flags/1x1/au.svg?ac70d22dd0c26fae055be90d2c00f187";